/* src/modules/courses/action_types.js */

export const fetchCoursesAdminTypes = [
  'FETCH_COURSES_ADMIN',
  'FETCH_COURSES_ADMIN_SUCCESS',
  'FETCH_COURSES_ADMIN_FAIL',
];

export const fetchCoursesTypes = [
  'FETCH_COURSES',
  'FETCH_COURSES_SUCCESS',
  'FETCH_COURSES_FAIL',
];

export const addCourseTypes = [
  'ADD_COURSE',
  'ADD_COURSE_SUCCESS',
  'ADD_COURSE_FAIL',
];

export const editCourseTypes = [
  'EDIT_COURSE',
  'EDIT_COURSE_SUCCESS',
  'EDIT_COURSE_FAIL',
];

export const removeCourseTypes = [
  'REMOVE_COURSE',
  'REMOVE_COURSE_SUCCESS',
  'REMOVE_COURSE_FAIL',
];

export const searchCoursesTypes = [
  'SEARCH_COURSES',
  'SEARCH_COURSES_SUCCESS',
  'SEARCH_COURSES_FAIL',
];

export const SET_COURSE_PAGE = 'SET_COURSE_PAGE';
export const SET_COURSE_PAGE_COUNT = 'SET_COURSE_PAGE_COUNT';



// WEBPACK FOOTER //
// ./src/modules/courses/action_types.js